import { render, staticRenderFns } from "./ClimbingSessionDetail.vue?vue&type=template&id=2e219a46"
import script from "./ClimbingSessionDetail.vue?vue&type=script&lang=js"
export * from "./ClimbingSessionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports